import seqStore from '../../store/seqStore'

export default function Offset() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const offset = seqStore((state) => state.settings.offset)
    const setOffset = seqStore((state) => state.setOffset)
    const length = seqStore((state) => state.settings.length)

    // OFFSET CONTROLS
    const handleOffset = (e) => {
        const value = 0 - e.target.value
        setOffset(currentTrack, value)
    }

    const resetOffset = () => {
        setOffset(currentTrack, 0)
        }
    
    return (
        <div id='offsetInput'>
            <label htmlFor="root note">Offset <span>{offset[currentTrack]}</span></label>
            <input id='enabledInput' type="range" min={-(length[currentTrack] - 1)} max={length[currentTrack] - 1} step='1' value={0 - offset[currentTrack]} onChange={e => handleOffset(e)} onDoubleClick={resetOffset}/>
        </div>
    )
}
